import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Row } from '@fs/zion-ui'
import { ArrowCaret } from '@fs/zion-icon'
import { useRootsTechBannerContext } from './RootsTechBannerProvider'
import styles from './RootsTechBannerTextStyles.module.css'

export default function RootsTechBannerOpenCloseIcon({ isTablet }) {
  const { t } = useTranslation()
  const { isOpen, toggleBanner } = useRootsTechBannerContext()
  let label
  if (isOpen) {
    label = t('rt-banner.open-close-button.collapse', 'Collapse')
  } else {
    label = isTablet ? '' : t('rt-banner.open-close-button.expand', 'Expand')
  }

  const hoverText = isOpen ? t('rt-banner.banner-close', 'Close banner') : t('rt-banner.banner-open', 'Open banner')

  return (
    <Row justify="end" align="center">
      <Button
        onClick={toggleBanner}
        size="sm"
        color="purple"
        emphasis="lightHigh"
        aria-label={hoverText}
        aria-expanded={isOpen}
        title={hoverText}
        Icon={ArrowCaret}
        iconAtEnd
        iconDirection={isOpen ? 'up' : 'down'}
      >
        <span className={styles.normalCase}>{label}</span>
      </Button>
    </Row>
  )
}
